import SectionHeader from '../../../../components/SectionHeader/SectionHeader';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import Section from '../Section';
import PriceDevelopment from './PriceDevelopment';
import GridComponent from '../GridComponent/GridComponent';
import { useCommoditiesStore } from '../../hooks/useCommoditiesStore';
import useAppContext from '../../../../hooks/context/useAppContext';

const Prices = ({ customerId }) => {
  const { commodities } = useCommoditiesStore();
  const { user } = useAppContext();

  return (
    <Section>
      <SectionHeader>
        <FormattedMessage id={'app.priceDevelopment.label'} />
      </SectionHeader>
      <GridComponent
        components={commodities.map((commodity, index) => (
          <PriceDevelopment
            key={index}
            type={commodity.type}
            years={commodity.years}
            userId={user?.id}
            customerId={customerId}
            userRole={user?.role}
          />
        ))}
      />
    </Section>
  );
};

Prices.propTypes = {
  customerId: PropTypes.number,
};

export default Prices;
